export default "__VITE_ASSET__DtQBqJNk__"